import React from 'react';

import { VARIANTS as LOGO_VARIANTS } from '@prisjakt/ui-store-logo';
import { BodySmallText, FontEmphasis } from '@prisjakt/ui/text/variants';
import { Price } from '../price';
import { ProductName } from '../product-name';

import {
  Content,
  PriceWrapper,
  Properties,
  Rating,
  ShopLogo,
  StyledPrice,
} from './styles';

import { BaseProps, ProductProperty } from '../../types';

type Props = Pick<
  BaseProps,
  | 'category'
  | 'diffPercentage'
  | 'highlightedName'
  | 'name'
  | 'price'
  | 'properties'
  | 'rank'
  | 'rating'
  | 'reviewsCount'
  | 'store'
> & {
  smallerProductCardsMobileExperiment?: boolean;
};

export const GridCardContent: React.FC<Props> = props => {
  const {
    category,
    diffPercentage,
    highlightedName,
    name,
    price,
    properties,
    rank,
    rating,
    reviewsCount,
    store,
    smallerProductCardsMobileExperiment,
  } = props;

  const coreProperties = mapToCoreProperties(properties);
  return (
    <Content>
      <ProductName>{highlightedName || name}</ProductName>

      {category?.name && !rank && (
        <BodySmallText emphasis={FontEmphasis.MEDIUM}>
          {category.name}
        </BodySmallText>
      )}
      {typeof coreProperties === 'string' && (
        <Properties
          smallerProductCardsMobileExperiment={
            smallerProductCardsMobileExperiment
          }
        >
          <BodySmallText emphasis={FontEmphasis.MEDIUM}>
            {coreProperties}
          </BodySmallText>
        </Properties>
      )}

      {rating && rating > 0 ? (
        <Rating rate={rating} count={reviewsCount} showCounterAs="number" />
      ) : null}

      {price != null && (
        <PriceWrapper gap={0.5}>
          <StyledPrice>
            <Price
              price={price}
              isDeal={Boolean(diffPercentage)}
              currency={store?.currency}
            />
          </StyledPrice>

          {store && Object.keys(store).length !== 1 && (
            <ShopLogo
              variant={LOGO_VARIANTS.CAMPAIGN}
              name={store.name}
              storeId={store.id}
              featured
              hasImage={store.hasLogo || false}
            />
          )}
        </PriceWrapper>
      )}
    </Content>
  );
};

function mapToCoreProperties(properties: ProductProperty[] | null | undefined) {
  return Array.isArray(properties)
    ? properties
        .filter(({ isCore, pretty }) => isCore && pretty !== null)
        .map(({ pretty }) => pretty)
        .join(', ')
    : null;
}
